"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewModalOnMobile = void 0;

var _utils = require("../../utils");

const viewModalOnMobile = {
  name: 'viewModalOnMobile',
  enabled: true,
  phase: 'beforeWrite',

  fn(_ref) {
    let {
      state
    } = _ref;

    if ((0, _utils.isTablet)()) {
      state.styles.popper = {
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        transform: 'none'
      };
    }
  }

};
exports.viewModalOnMobile = viewModalOnMobile;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ2aWV3TW9kYWxPbk1vYmlsZSIsIm5hbWUiLCJlbmFibGVkIiwicGhhc2UiLCJmbiIsInN0YXRlIiwiaXNUYWJsZXQiLCJzdHlsZXMiLCJwb3BwZXIiLCJsZWZ0IiwicmlnaHQiLCJ0b3AiLCJib3R0b20iLCJ0cmFuc2Zvcm0iXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Ub29sdGlwL1Rvb2x0aXAubW9kaWZpZXJzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE1vZGlmaWVyIH0gZnJvbSAnQHBvcHBlcmpzL2NvcmUnXG5pbXBvcnQgeyBpc1RhYmxldCB9IGZyb20gJ351dGlscydcblxuZXhwb3J0IGNvbnN0IHZpZXdNb2RhbE9uTW9iaWxlOiBNb2RpZmllcjwndmlld01vZGFsT25Nb2JpbGUnLCBSZWNvcmQ8c3RyaW5nLCB1bmtub3duPj4gPSB7XG4gIG5hbWU6ICd2aWV3TW9kYWxPbk1vYmlsZScsXG4gIGVuYWJsZWQ6IHRydWUsXG4gIHBoYXNlOiAnYmVmb3JlV3JpdGUnLFxuICBmbih7IHN0YXRlIH0pIHtcbiAgICBpZiAoaXNUYWJsZXQoKSkge1xuICAgICAgc3RhdGUuc3R5bGVzLnBvcHBlciA9IHtcbiAgICAgICAgbGVmdDogJzAnLFxuICAgICAgICByaWdodDogJzAnLFxuICAgICAgICB0b3A6ICcwJyxcbiAgICAgICAgYm90dG9tOiAnMCcsXG4gICAgICAgIHRyYW5zZm9ybTogJ25vbmUnLFxuICAgICAgfVxuICAgIH1cbiAgfSxcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztBQUVPLE1BQU1BLGlCQUF5RSxHQUFHO0VBQ3ZGQyxJQUFJLEVBQUUsbUJBRGlGO0VBRXZGQyxPQUFPLEVBQUUsSUFGOEU7RUFHdkZDLEtBQUssRUFBRSxhQUhnRjs7RUFJdkZDLEVBQUUsT0FBWTtJQUFBLElBQVg7TUFBRUM7SUFBRixDQUFXOztJQUNaLElBQUksSUFBQUMsZUFBQSxHQUFKLEVBQWdCO01BQ2RELEtBQUssQ0FBQ0UsTUFBTixDQUFhQyxNQUFiLEdBQXNCO1FBQ3BCQyxJQUFJLEVBQUUsR0FEYztRQUVwQkMsS0FBSyxFQUFFLEdBRmE7UUFHcEJDLEdBQUcsRUFBRSxHQUhlO1FBSXBCQyxNQUFNLEVBQUUsR0FKWTtRQUtwQkMsU0FBUyxFQUFFO01BTFMsQ0FBdEI7SUFPRDtFQUNGOztBQWRzRixDQUFsRiJ9